import { inject, Injectable } from '@angular/core';
import { catchError, map, type Observable, of } from 'rxjs';
import { toDataResult, ToResult } from '@team23/ts-result';
import {
    FilterConfigService,
    type FilterDataResult,
    FilterDataStatus,
    MultiFilterModel,
} from '@ui/shared/util-filter';
import { SportAtlasService } from '@ui/shared/util-api';
import type { SportMapFilterKey } from '../../types/sport-map-filter';
import { getAgeGroupLabelForAgeGroupDTO } from '../../util/age-group-label';

@Injectable({ providedIn: 'root' })
export class TargetGroupSelectFilterConfigService extends FilterConfigService<SportMapFilterKey, SportAtlasService> {
    public override type = 'multiselect' as const;

    constructor() {
        super(
            new MultiFilterModel('targetGroup', 'Altersgruppe', []),
            inject(SportAtlasService),
        );
    }

    protected _getOptions$(): Observable<FilterDataResult> {
        return this._api.getAllAgeGroups({
        })
            .pipe(
                map(result =>
                    result.data.map(dto => ({
                        value: dto.id,
                        label: getAgeGroupLabelForAgeGroupDTO(dto),
                    })),
                ),
                toDataResult(),
                catchError(() => of(ToResult.fromErrorKey(FilterDataStatus.Generic))),
            );
    }
}
